export default function(ngModule) {
    /**
     * @ngdoc service
     * @name eventix.common.models.TicketReservation
     * @kind class
     * @description
     * Model that holds returned data from API reservation call and augments it with
     * product/ticket details & convenience methods
     *
     * Does *not* inherit from `base-class`
     */
    ngModule.factory('GlobalProductReservation', function(BCAPIMessages, Shop, Product) {
        const ISO8601 = 'YYYY-MM-DDTHH:mm:ssZ';

        /**
         * Construct a global product reservation
         * @param {object} reservation the reservation object
         * @param {object} shop the shop object
         * @return {GlobalProductReservation} Returns global product reservation
         */
        function GlobalProductReservation(reservation, shop) {
            _.assign(this, reservation);
            this.reservedOn = moment();
            this.shop = Shop.cached.first();
            let reservationTime = angular.isNumber(shop.reservation_time) && shop.reservation_time > 0 ? shop.reservation_time : 8;
            this.expiration = moment().add(reservationTime, 'minutes').format(ISO8601);
            this.product = Product.cached[this.product_guid];
            return this;
        }

        (() => {
            BCAPIMessages.apply(GlobalProductReservation);
            GlobalProductReservation.prototype.broadcastAPIMessage = GlobalProductReservation.__broadcastAPIMessage;

            GlobalProductReservation.configureAPIMessages({
                '/:guid/reserve/ticket/:tguid': {
                    400: 'models.ticket.notice.soldOut',
                    406: 'models.ticket.notice.maxReserved'
                },
                '/:guid/reserve/ticket/:tguid/product/:pguid': {
                    400: 'models.product.notice.soldOut',
                    406: 'models.product.notice.maxReserved'
                }
            });
        })();

        GlobalProductReservation.prototype.calculatePrice = function(om) {
            return this.product.displayGlobalPrice(om);
        };

        /**
         * Prepare the data for the order submit
         * @return {Object} Data for order call
         */
        GlobalProductReservation.prototype.prepareData = function() {
            const globalProductReservation = this;
            return {
                guid: globalProductReservation.product_guid,
                reservation: globalProductReservation.reservation,
                metaData: []
            };
        };

        return GlobalProductReservation;
    });
}
